// extracted by mini-css-extract-plugin
export default {"item":"ingredient_item__2pLNT"};